module.exports = __webpack_public_path__ + "img/icn_last.6e758378.svg";